import React, { useState, useEffect } from 'react';

import { Container, Row, Col, Card, CardBody } from 'reactstrap';
// import * as Yup from "yup";
// import { useFormik } from "formik";
import { useSelector, useDispatch } from 'react-redux';
import avatar from '../../assets/images/users/avatar-1.jpg';
import { getUser } from 'slices/thunks';
import { createSelector } from 'reselect';
import PrismCode from 'Components/Common/Prism';

const UserInfoPage = () => {
  const dispatch: any = useDispatch();

  const [username, setUsername] = useState('admin@gmail.com');
  const [userName, setUserName] = useState('Admin');
  const [storeName, setStoreName] = useState('posapp');

  const selectUserState = (state: any) => state.User;
  const userData = createSelector(selectUserState, (state) => ({
    user: state.user,
    success: state.success,
    error: state.error,
  }));

  // const { user, success, error } = useSelector(userData);
  const { user } = useSelector(userData);

  // Fetch user data when component mounts
  useEffect(() => {
    const storedUser = sessionStorage.getItem('authUser');
    if (storedUser) {
      const userInfo: any = sessionStorage.getItem('user');
      const parsedUser = JSON.parse(userInfo);
      setUsername(parsedUser.username);
      setUserName(parsedUser.username);
      setStoreName(parsedUser.store_name);
      dispatch(getUser());
    }
  }, [dispatch]);

  document.title = 'Profile | Velzon - React Admin & Dashboard Template';

  return (
    <React.Fragment>
      <div className="page-content mt-lg-5">
        <Container fluid>
          <Row>
            <Col lg="12">
              {/* User profile card */}
              <Card>
                <CardBody>
                  <div className="d-flex">
                    <div className="mx-3">
                      <img
                        src={avatar}
                        alt=""
                        className="avatar-md rounded-circle img-thumbnail"
                      />
                    </div>
                    <div className="flex-grow-1 align-self-center">
                      <div className="text-muted">
                        <h5>{userName || 'Admin'}</h5>
                        <p className="mb-1">Username : {username}</p>
                        <p className="mb-1">Store name : {storeName}</p>
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          {/* Display user profile information */}
          <Card>
            <CardBody>
              <h5>/auth/user/me</h5>
              {/* Display fetched data using PrismCode */}
              <PrismCode
                code={JSON.stringify(user, null, 2)}
                language={'json'}
              />
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default UserInfoPage;
